import { useQuery } from "@tanstack/react-query"
import { classes } from  '@shared/api/services'

const POLL_INTERVAL = 1000
// При ошибках не долбим сервер каждую секунду
const POLL_INTERVAL_ON_ERROR = 5000

export const useAppointment = (appointmentId, enableLongPulling) => {
	return useQuery({
		queryKey: ['appointment', appointmentId],
		queryFn: ({ signal }) => classes.getClassById(appointmentId, { signal }),
		enabled: !!appointmentId,
		select: (data) => data.data,
		refetchInterval: (query) => {
			if (!enableLongPulling) return undefined
			return query.state.status === 'error' ? POLL_INTERVAL_ON_ERROR : POLL_INTERVAL
		}
	})
}
